import React from "react";
import { createTheme } from "@mui/material/styles";
import { Remarkable } from "remarkable";
import clsx from "clsx";

import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import {
  theme as websiteTheme,
  styles as websiteStyles,
} from "./websiteVariables";

const md = new Remarkable({ html: true });

const useStyles = makeStyles(websiteStyles);

function ArticlePreview({ mdContent }) {
  const classes = useStyles();

  return (
    <div className={classes.main}>
      <div
        dangerouslySetInnerHTML={{ __html: md.render(mdContent) }}
        className={clsx(classes.article, classes.artist)}
      />
    </div>
  );
}

const theme = createTheme(websiteTheme);

export default function ThemedArticlePreview(props) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ArticlePreview {...props} />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
